import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Question } from '@app/models/question';
import { User } from '@app/models/user';

@Component({
	selector: 'app-atom-question-radio',
	templateUrl: './atom-question-radio.component.html',
	styleUrls: ['./atom-question-radio.component.less'],
})
export class AtomQuestionRadioComponent implements OnInit {
	@Input() question: Question;
	@Input() user: User;
	@Output() answerUpdate = new EventEmitter<string>();

	@Input() selectedAnswer: string;

	constructor() {}

	async ngOnInit() {}

	emitAnswer() {
		setTimeout(() => this.answerUpdate.emit(this.selectedAnswer), 500);
	}
}
